import { FinanceEntry } from "@/types";
import { useQuery } from "@tanstack/react-query";
import { httpRequest } from "@/lib/axios";

type Props = {
  id: string;
};

async function fetchFinanceEntryById({ id }: Props): Promise<FinanceEntry> {
  const response = await httpRequest.get<FinanceEntry>(
    `/finance-entries/${id}`
  );
  return response.data;
}

export function useFetchFinanceEntryByIdQuery({ id }: Props) {
  const financeEntryQuery = useQuery({
    queryKey: ["finance-entries", id],
    queryFn: () => fetchFinanceEntryById({ id }),
    keepPreviousData: false,
    enabled: !!id,
  });

  return {
    ...financeEntryQuery,
    data: financeEntryQuery.data,
  };
}
